import * as types from '../mutation-types'

// initial state
const state = {
    user: '',
    token: '',
    expiryDate: null,
    email: '',
    isPublicUser: false,
    userCompanies: [],
    selectedCompany: {},
    loaded: false,
    initLocation: '',
}

const getters = {
    // user: state => state.user,
    token: state => state.token,
    expiryDate: state => state.expiryDate,
    email: state => state.email,
    isPublicUser: state => state.isPublicUser,
    userCompanies: state => state.userCompanies,
    selectedCompanyId: state => state.selectedCompany.idCompany,
    selectedCompanyName: state => state.selectedCompany.name,
    isLoggedIn: state => !!state.token,
    initLocation: state => state.initLocation,
}

const actions = {
    setToken({ commit }, token) {
        commit(types.SET_TOKEN,  token );
    },
    setPublicUser({ commit }, bool) {
        commit(types.SET_PUBLIC_USER,  bool );
    },
    setEmail({ commit }, email) {
        commit(types.SET_EMAIL,  email );
    },
    setUserCompanies({ commit }, companies) {
        commit(types.SET_USER_COMPANIES,  companies );
    },
    setUserCompany({ commit }, company) {
        commit(types.SET_USER_COMPANY,  company );
    },
    setInitLocation({ commit }, url) {
        commit('set_init_location',  url );
    },
    clearStorage() {
        localStorage.removeItem('vuex')
    }
}

const mutations = {
    [types.SET_TOKEN] (state, token ) {
        state.token = token
        if(token === null) {
            state.expiryDate = null
            return
        }
        state.expiryDate = new Date().getTime() + 8 * 3600 * 1000 //8 hours
    },
    [types.SET_PUBLIC_USER] (state, bool ) {
        state.isPublicUser = bool
    },
    [types.SET_EMAIL] (state, email ) {
        state.email = email
    },
    [types.SET_USER_COMPANIES] (state, companies ) {
        state.userCompanies = companies.sort((a,b) => {
            return a.name.localeCompare(b.name)
        })
    },
    [types.SET_USER_COMPANY] (state, company ) {
        state.selectedCompany = company
        window._paq.push(['setCustomDimension', 1, company.name])
        window._paq.push(['setCustomDimension', 2, company.name])
    },
    'set_init_location' (state, url ) {
        state.initLocation = url
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}
